import * as yup from 'yup';

import { HOURS_DECIMALS } from '../../EmploymentHours.consts';

import type { TFunction } from 'i18next';
import type { CorrectionEditableKey } from './correctionSpec.types';

/**
 * Built per open, from the keys the CLA flags actually expose — a factory so `t()` resolves against
 * the current language (precedent: `additionalProperties/additionalPropertySchema.ts`).
 *
 * Dojo constrained every input with `{ fractional: true, places: '0,2' }`
 * (`EmployeeHoursCorrectionForm.js:13-16`): a number with at most two decimals, or empty.
 */
export const getHoursCorrectionSchema = (
  editableKeys: CorrectionEditableKey[],
  t: TFunction
) => {
  const hours = yup
    .number()
    .nullable()
    // an emptied input arrives as NaN through the resolver; treat it as "not corrected"
    .transform((value) => (Number.isNaN(value) ? null : value))
    .test(
      'twoDecimals',
      t('employmentHours.corrections.twoDecimalsError'),
      (value) =>
        value === null ||
        value === undefined ||
        Number(value.toFixed(HOURS_DECIMALS)) === value
    );

  const numericFields = Object.fromEntries(
    editableKeys
      .filter((key) => key !== 'inputWorkingMemo')
      .map((key) => [key, hours])
  );

  return yup.object({
    ...numericFields,
    inputWorkingMemo: yup.string(),
    flags: yup.array().of(yup.string())
  });
};
